const projectsData = [
  {
    id: 1,
    title: "RadarPet - Localizador de Mascotas",
    description: "Aplicación innovadora para localizar mascotas perdidas utilizando tecnología GPS y redes sociales. Conecta a dueños de mascotas con la comunidad para facilitar el reencuentro.",
    technologies: ["React", "Node.js", "MongoDB", "GPS API", "Socket.io"],
    image: "https://i.ibb.co/p60BTCdS/logonuevo.png",
    github: "MicaelaKloster/radarPet",
    url: "git@github.com:MicaelaKloster/radarPet.git",
    web: "https://radar-pet.vercel.app/"
  },
  {
    id: 2,
    title: "Academia For IT - Agenda Simple",
    description: "Aplicación web de agenda simple y funcional desarrollada con tecnologías modernas. Permite gestionar tareas y eventos de manera intuitiva.",
    technologies: ["React", "JavaScript", "CSS", "Vercel"],
    image: "https://i.imgur.com/h5EKdcH.png",
    github: "ignacio-Jose-Rocha/academiaForIT",
    url: "https://github.com/ignacio-Jose-Rocha/academiaForIT",
    web: "https://academia-for-it.vercel.app/"
  },
  {
    id: 3,
    title: "El Rincón del Vino (E-commerce)",
    description: "Proyecto Final Laboratorio 4 - Desarrollo de una aplicación web full-stack para ventas de vinos.",
    technologies: ["React", "Node.js", "MongoDB"],
    image: "https://github.com/CodeStrong2023/404notFound-4sTP/raw/main/client/assets/navegaci%C3%B3n.png",
    github: "CodeStrong2023/404notFound-4sTP",
    url: "https://github.com/CodeStrong2023/404notFound-4sTP"
  },
  {
    id: 4,
    title: "Clinica Medicus",
    description: "Sitio web full-stack para clínica médica con sistema de citas y gestión de pacientes.",
    technologies: ["React", "Node.js", "PostgreSQL", "JWT", "Nodemailer"],
    image: "https://i.imgur.com/Sn3Hk6Q.png",
    github: "ignacio-Jose-Rocha/medicus",
    url: "https://github.com/ignacio-Jose-Rocha/medicus",
    web: "https://medicus-clinica.vercel.app/login"
  },
  {
    id: 5,
    title: "Gimnasio Center Fit",
    description: "Sitio web full-stack para gimnasio con sistema de reservas y gestión de membresías.",
    technologies: ["React", "Node.js", "MongoDB"],
    image: "https://i.ibb.co/HTdc5RyK/centerfit.png",
    github: "ignacio-Jose-Rocha/gimFront",
    url: "https://github.com/ignacio-Jose-Rocha/gimFront",
    web: "https://centerfit.vercel.app/"
  },
  {
    id: 6,
    title: "Visión Películas",
    description: "Plataforma de películas desarrollada para Alkemy con búsqueda avanzada y recomendaciones.",
    technologies: ["React", "API Rest", "TailwindCSS"],
    image: "https://i.imgur.com/y1C4ZuP.png",
    github: "ignacio-Jose-Rocha/vision-peliculas",
    url: "https://github.com/ignacio-Jose-Rocha/vision-peliculas"
  },
  {
    id: 7,
    title: "Sitio Web Colegio La Rioja",
    description: "Proyecto de Pasantía - Desarrollo de un sitio web institucional con sistema de gestión académica.",
    technologies: ["HTML", "CSS", "JavaScript"],
    image: "https://i.imgur.com/5HXiadn.png",
    github: "DiegoRafaelRamosLlanos/tecnicoIndd/tree/ignacio",
    url: "https://github.com/DiegoRafaelRamosLlanos/tecnicoIndd/tree/ignacio"
  },
  {
    id: 8,
    title: "API Rick y Morty",
    description: "Aplicación React que consume la API de Rick y Morty con filtros avanzados y favoritos.",
    technologies: ["React", "API", "CSS Modules"],
    image: "https://i.imgur.com/xFyb63k.png",
    github: "ignacio-Jose-Rocha/api-rick-morty",
    url: "https://github.com/ignacio-Jose-Rocha/api-rick-morty"
  },
  {
    id: 9,
    title: "Chat Bot UTN",
    description: "Bot inteligente para la UTN con capacidades de envío de emails y respuestas automatizadas.",
    technologies: ["HTML", "CSS", "JavaScript"],
    image: "https://i.imgur.com/0v9Bebt.png",
    github: "ignacio-Jose-Rocha/chatBotEnvioMailUTN",
    url: "https://github.com/ignacio-Jose-Rocha/chatBotEnvioMailUTN"
  },
  {
    id: 10,
    title: "Gestor de Deudas",
    description: "Aplicación web para gestionar y controlar deudas personales de manera eficiente.",
    technologies: ["React", "JavaScript", "CSS"],
    image: "https://i.ibb.co/Zzc0mTf7/imagen.png",
    web: "https://gestor-deudas-lilac.vercel.app/"
  }
];

export default projectsData;

